import { useQuery } from '@tanstack/react-query'
import { PlusIcon } from 'lucide-react'
import { Button, ButtonProps } from '../../../components'
import { useCogfy } from '../../../hooks'
import { useEffect, useRef } from 'react'
import { popupCenter } from '../../../helpers/popup-center'

type AddJiraButtonProps = {
  onSuccess?: () => void
}

export function AddJiraButton (props: AddJiraButtonProps & ButtonProps) {
  const { onSuccess } = props

  const cogfy = useCogfy()
  const windowRef = useRef<Window | null>(null)
  const intervalRef = useRef<NodeJS.Timeout | null>(null)

  const data = {
    provider: 'jira' as const
  }
  const getJiraAuthUrl = useQuery({
    queryKey: ['getJiraAuthUrl', data],
    queryFn: ({ signal }) => cogfy.getJiraAuthUrl(data, { signal })
  })

  const checkPopupClosed = () => {
    if (windowRef.current && windowRef.current.closed) {
      clearInterval(intervalRef.current!)
      intervalRef.current = null
      onSuccess?.()
    }
  }

  const openPopup = () => {
    if (getJiraAuthUrl.data?.authUrl) {
      windowRef.current = popupCenter(getJiraAuthUrl.data.authUrl)
      intervalRef.current = setInterval(checkPopupClosed, 200)
    }
  }

  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }
  }, [])

  return (
    <Button
      color={props.color}
      size={props.size || 'sm'}
      disabled={getJiraAuthUrl.isLoading}
      onClick={openPopup}
      className={props.className}
    >
      <PlusIcon size={16} />
      {props.children}
    </Button>
  )
}
